var colorRelationElements = document.getElementsByClassName(
  'color-relation-item'
);
var textElement = document.getElementById('color-selector-title');

Array.from(colorRelationElements).forEach((colorRelation) => {
  colorRelation.addEventListener('mouseover', () => {
    ChangeText(colorRelation.dataset.color);
  });
  colorRelation.addEventListener('mouseout', () => {
    ChangeText(textElement.dataset.currentTitle);
  });
});

function ChangeText(color) {
  if (textElement?.innerHTML != color) {
    textElement.innerHTML = color;
  }
}
